import { FormControlLabel, Stack, Switch, Typography } from '@mui/material'
import {
  useGetMyNotificationPreference,
  useUpdateMyNotificationPreference,
} from '@/service-library/hooks/notifications'
import { showErrorSnackbar } from '@/utils/snackbars'

export default function NotificationPreferences() {
  const { notificationPreference, isPending } = useGetMyNotificationPreference()
  const { updateNotificationPreference, isPending: isSaving } =
    useUpdateMyNotificationPreference({
      onError: () => {
        showErrorSnackbar('Failed to update email notifications.')
      },
    })

  const emailEnabled = notificationPreference?.email_enabled ?? true

  return (
    <Stack spacing={1}>
      <div>
        <Typography variant="body1">Email notifications</Typography>
        <Typography variant="body2" color="text.secondary">
          Get an email when something needs your attention.
        </Typography>
      </div>
      <FormControlLabel
        control={
          <Switch
            checked={emailEnabled}
            // One save at a time, so saves can't land out of order
            disabled={isPending || isSaving}
            onChange={(e) => {
              updateNotificationPreference({ email_enabled: e.target.checked })
            }}
          />
        }
        label={emailEnabled ? 'On' : 'Off'}
        // Pull the switch's built-in padding back so its track lines up with
        // the text. The Stack's spacing resets margins, hence !important.
        sx={{ width: 'fit-content', ml: '-12px !important' }}
      />
      <Typography variant="body2" color="text.secondary">
        Notifications always appear in Pixydocs, whatever this is set to. Push
        notifications are turned on or off in your phone or browser settings.
      </Typography>
    </Stack>
  )
}
